<template>
  <div>
    <div class="text-xxs" style="margin-bottom: 2px;">
      <slot name="label" />
    </div>
    <ul ref="menu" class="relative">
      <li>
        <div class="sky__select-box justify-between" @click="toggleMenu">
          <div class="flex items-center">
            <slot name="current" />
          </div>
          <icon-select-down style="width: 10px;" />
        </div>
      </li>
      <li>
        <ul
          :class="{hidden: !menu}"
          class="absolute left-0 right-0"
          style="max-height: 200px; overflow: auto;"
        >
          <li
            v-for="variant in variants"
            :key="variant.sku"
            class="z-50 relative"
          >
            <nuxt-link :to="$helpers.makeUri(variant.path)" class="sky__select-box selectable" @click="$emit('click:variant', variant)">
              <slot name="item" :item="variant" />
            </nuxt-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    variants: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      menu: false
    }
  },
  beforeDestroy () {
    this.closeMenu()
  },
  methods: {
    closeMenu () {
      this.menu = false
      document.removeEventListener('click', this.closeListener)
    },
    closeListener (e) {
      if (!this.$refs.menu.contains(e.target)) {
        this.closeMenu()
      }
    },
    openMenu () {
      this.menu = true
      document.addEventListener('click', this.closeListener)
    },
    toggleMenu () {
      if (this.menu) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    }
  }
}
</script>
